import { combineReducers } from 'redux';
import { CLEAR_SESSION } from './auth/actions';

import StatusReducers from './status/reducers';
import AuthReducers from './auth/reducers';
import ProductAggregatesReducers from './product-aggregates/reducers';
import PurchasingReducers from './purchasing/reducers';
import ProductInventoriesReducers from './product-inventories/reducers';
import ImporterStatsReducers from './importer-stats/reducers';
import VendorsReducers from './vendors/reducers';
import UserPrefsReducers from './users/prefs_reducers';
import GlobalSettingsReducers from './global-settings/reducers';
import VerificationReducers from './verification/reducers';
import ForgotPwReducers from './forgotpw/reducers';

import VendorDashboardReducers from './vendors/dashboard-reducers';

import GlobalSettingsVarietalsReducers from './global-settings/varietals/reducers';
import GlobalSettingsROIReducers from './global-settings/roi-values-reducers';
import GlobalSettingsPermissionReducers from './global-settings/permissions/reducers';

import ROICalculatorReducers from './roi-calculator/reducers';

import GlobalSettingsSalesGroupsReducers from './global-settings/sales-groups/reducers';

import PPMReducers from './ppm/reducers';
import StatementsReducers from './statements/reducers';

// Define the root reducer which combines all the separate reducers.
const AppReducer = combineReducers({
  status: StatusReducers,
  auth: AuthReducers,
  productAggregates: ProductAggregatesReducers,
  purchasing: PurchasingReducers,
  productInventories: ProductInventoriesReducers,
  importerStats: ImporterStatsReducers,
  vendors: VendorsReducers,
  userPrefs: UserPrefsReducers,
  globalSettings: GlobalSettingsReducers,
  globalSettingsVarietals: GlobalSettingsVarietalsReducers,
  globalSettingsROI: GlobalSettingsROIReducers,
  globalSettingsSalesGroups: GlobalSettingsSalesGroupsReducers,
  globalSettingsPermissions: GlobalSettingsPermissionReducers,
  verification: VerificationReducers,
  forgotPw: ForgotPwReducers,
  vendor: combineReducers({
    dashboard: VendorDashboardReducers
  }),
  roiCalculator: ROICalculatorReducers,
  ppm: PPMReducers,
  statements: StatementsReducers
});

const RootReducer = (state, action) => {
  // Clear all data in redux store to initial.
  if (action.type === CLEAR_SESSION) {
    state = undefined;
  }

  return AppReducer(state, action);
};

export default RootReducer;
